import { render } from "./LandingClientesComponent.vue?vue&type=template&id=ffd69cce"
import script from "./LandingClientesComponent.vue?vue&type=script&lang=js"
export * from "./LandingClientesComponent.vue?vue&type=script&lang=js"

import "./LandingClientesComponent.vue?vue&type=style&index=0&id=ffd69cce&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__